export function persistAuthSession({ token, user, rememberDevice, identifier }) {
  if (!token) {
    return
  }

  localStorage.setItem('authToken', token)

  if (user) {
    localStorage.setItem('user', JSON.stringify(user))
  }

  if (rememberDevice) {
    localStorage.setItem('rememberEmail', identifier)
  } else {
    localStorage.removeItem('rememberEmail')
  }
}
